<template>
    <v-dialog persistent v-if="child_dialog" v-model="child_dialog" max-width="80%">
        <app-card>
            <app-section-loader
                :status="loading.submit"
            ></app-section-loader>
            <v-btn right icon absolute small @click="child_dialog = false">
                <v-icon>close</v-icon>
            </v-btn>
            <h4>CẮT LINE VNPT USER {{internet_user.user}}</h4>
            <p class="fs-14 grey--text mb-1">
                Tên User:
                <strong>{{ internet_user.user }}</strong>
            </p>
            <p class="fs-14 grey--text mb-1">
                Giá gói:
                <strong>{{ internet_user.price | formatNumber }} VND</strong>
            </p>
            <p class="fs-14 grey--text mb-1">
                Tòa nhà:
                <strong>{{ internet_user.building_text || internet_user.building }}</strong>
            </p>
            <p class="fs-14 grey--text mb-1">
                Số phòng:
                <strong>{{ internet_user.room_id }}</strong>
            </p>
            <v-form ref="form">
                <v-container fluid>
                    <v-layout row wrap justify-center>
                        <v-flex xs12 md6>
                            <v-menu
                                :close-on-content-click="false"
                                v-model="menu_date_cut"
                                :nudge-right="40"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                min-width="290px"
                            >
                                <v-text-field
                                    slot="activator"
                                    v-model="form.date_cut"
                                    label="Ngày cắt mạng"
                                    :disabled="loading.submit"
                                    prepend-icon="event"
                                    readonly
                                    :rules="[rules.required]"
                                ></v-text-field>
                                <v-date-picker locale="vi-VI" v-model="form.date_cut" @input="menu_date_cut = false"></v-date-picker>
                            </v-menu>
                        </v-flex>
                        <v-flex xs12 md6>
                            <v-text-field
                                label="Ghi chú"
                                :disabled="loading.submit"
                                v-model="form.note"
                                prepend-icon="event_note"
                            >
                            </v-text-field>
                        </v-flex>
                    </v-layout>
                </v-container>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn :disabled="loading.submit" @click="cancelInput"
                        >Trở về</v-btn
                    >
                    <v-btn
                        :loading="loading.submit"
                        :disabled="loading.submit"
                        dark
                        color="green"
                        @click="submit"
                        >Xác nhận</v-btn
                    >
                </v-card-actions>
            </v-form>
        </app-card>
    </v-dialog>
</template>
<script>
import api from "../../api";

export default {
	name: "cut-internet-component",
	props: {
        dialog: {
            type: Boolean,
            default: false
        },
        internet_user: Object,
	},
	data() {
		return {
			loading: {
				submit: false
            },
            menu_date_cut: false,
			form: {
                note: "",
                date_cut: '',
            },
            rules: {
                required: value => !!value || 'Vui lòng điền thông tin này.',
            },
            child_dialog: false,
		};
	},
	watch: {
		dialog(nv){
            this.child_dialog = this.dialog
		},
		child_dialog(nv){
            this.$emit('changeDialogState', nv)
			if (!nv) this.clearInput();
        },
    },
	methods: {
		clearInput() {
			this.$refs.form.reset();
		},
		cancelInput() {
			this.child_dialog = false;
        },
        async submit(){
            if (!this.$refs.form.validate()) {
                swal.fire('Lỗi', 'Vui lòng điền đầy đủ thông tin', 'error');
                return
            }
            const postData = {
                _id: this.internet_user._id,
                date_cut: this.form.date_cut,
                note: this.form.note
            }
            this.loading.submit = true;
            const data = await api.cutInternetRoom(postData);
            this.loading.submit = false;
            if (data.status === 200){
                this.child_dialog = false;
                swal.fire('Thành công', data.data.message, "success");
                this.$emit("reloadTable", data.data.internet);
            } else {
                swal.fire('Lỗi', data.message, "error")
            }
        }
	}
};
</script>